// extracted by mini-css-extract-plugin
export default {"arrowUp":"ArrowUp_arrowUp__3CD9x"};